export default "__VITE_ASSET__U4WBdpLW__"